"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ATTRIBUTES = void 0;
var month = new Date().getMonth();
var year = new Date().getFullYear();
var DEFAULT_ATTRIBUTES = [{
  key: 1,
  customData: {
    title: 'Lorem ipsum dolor si amet',
    class: 'bg-red-600 text-white'
  },
  dates: new Date(year, month, 1)
}, {
  key: 2,
  customData: {
    title: 'Lorem ipsum dolor si amet',
    class: 'bg-blue-500 text-white'
  },
  dates: new Date(year, month, 2)
}, {
  key: 3,
  customData: {
    title: 'A Lorem ipsum dolor si amet',
    class: 'bg-blue-500 text-white'
  },
  dates: new Date(year, month, 5)
}, {
  key: 4,
  customData: {
    title: 'B Lorem ipsum dolor si amet',
    class: 'bg-indigo-500 text-white'
  },
  dates: new Date(year, month, 5)
}, {
  key: 5,
  customData: {
    title: 'C Lorem ipsum dolor si amet',
    class: 'bg-indigo-500 text-white'
  },
  dates: new Date(year, month, 5)
}, {
  key: 6,
  customData: {
    title: 'Lorem ipsum dolor si amet',
    class: 'bg-teal-500 text-white'
  },
  dates: new Date(year, month, 7)
}, {
  key: 7,
  customData: {
    title: 'Lorem ipsum dolor si amet',
    class: 'bg-pink-500 text-white'
  },
  dates: new Date(year, month, 11)
}, {
  key: 8,
  customData: {
    title: 'Lorem ipsum dolor si amet',
    class: 'bg-orange-500 text-white'
  },
  dates: {
    months: 5,
    ordinalWeekdays: {
      2: 1
    }
  }
}, {
  key: 9,
  customData: {
    title: 'Lorem ipsum dolor si amet',
    class: 'bg-pink-500 text-white'
  },
  dates: new Date(year, month, 22)
}, {
  key: 10,
  customData: {
    title: 'Lorem ipsum dolor si amet',
    class: 'bg-red-600 text-white'
  },
  dates: new Date(year, month, 25)
}];
exports.DEFAULT_ATTRIBUTES = DEFAULT_ATTRIBUTES;
var response = {
  'status': 'success',
  'message': 'get-success',
  'executionTime': 0.07472,
  'data': {
    'summary': {
      'orderId': [{
        id: 123,
        shipmentReference: '123123'
      }],
      'planId': ['GD00470', 'GD00438', 'GD00503', 'GD00506', 'GD00440', 'GD00491', 'GD00504', 'GD00495', 'GD00508'],
      'truckId': [{
        id: 123,
        plateNum: 123
      }],
      'driverId': [{
        id: 123,
        name: 'John Paul',
        totalDistance: 1234,
        totalTime: 6789
      }],
      'totalDistance': 1234,
      'totalTime': 6789,
      'totalOnTime': 'count of number on time per waypoint',
      'totalNotOnTime': 'count of number not on time per waypoint'
    },
    'data': [{
      'date': '2020-03-01',
      'summary': {
        'orderId': [{
          id: 123,
          shipmentReference: '123123'
        }],
        'planId': ['GD00470', 'GD00438', 'GD00503', 'GD00506', 'GD00440', 'GD00491', 'GD00504', 'GD00495', 'GD00508'],
        'truckId': [{
          id: 123,
          plateNum: 123
        }],
        'driverId': [{
          id: 123,
          name: 'John Paul',
          totalDistance: 1234,
          totalTime: 6789
        }],
        'totalDistance': 1234,
        'totalTime': 6789,
        'totalOnTime': 'count of number on time per waypoint',
        'totalNotOnTime': 'count of number not on time per waypoint'
      },
      'trucks': [{
        truckId: '...',
        plateNumber: '...',
        orderId: '...',
        shipmentReference: '...',
        projectCode: '...',
        planId: '...',
        driverId: '...',
        estimatedDistance: '...',
        estimatedTime: '...'
      }],
      'routes': [{
        _id: '...',
        code: '...',
        status: '...',
        driverId: '...',
        masterpointId: '...',
        waypointId: '...',
        orderId: '...',
        shipmentReference: '...',
        projectCode: '...',
        customerCode: '...',
        waypointType: '...',
        latitude: '...',
        longitude: '...',
        district: '...',
        displayAddress: '...',
        zone: '...',
        waitingTime: '...',
        handlingTime: '...',
        distance: '...',
        startTime: '...',
        time: '...',
        estimateTime: '...',
        runningTime: '...',
        processingTime: '...',
        endTime: '...',
        endRunningTime: '...',
        suggestedData: '...',
        actualData: '...',
        index: '...',
        planId: '...',
        customerId: '...',
        truckId: '...',
        plateNumber: '...',
        capacity: '...',
        additionalData: '...',
        updatedUser: '...',
        createdUser: '...',
        updatedAt: '...',
        createdAt: '...',
        new: '...'
      }]
    }]
  }
};